const adsCheckerScript = `
var canRunAds = true;
`;

export default adsCheckerScript;
